import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=2da13df4&"
import script from "./Registration.vue?vue&type=script&lang=js&"
export * from "./Registration.vue?vue&type=script&lang=js&"
import style0 from "./fonts/iconic/css/material-design-iconic-font.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./css/login.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports